import { sva } from '@portal/styled-system/css'

const minGameHeight = '688px'
const minGameWidth = '775px'
const maxGameHeight = '3000px'
const maxGameWidth = '3000px'

export const gameLayout = sva({
    slots: ['container', 'content'],
    base: {
        container: {
            flex: ['1', '1', 'auto'],
            position: 'relative',
            overflowY: 'auto',
            width: 'full',
            height: '[calc(100vh - var(--play-nav-height))]',
        },
        content: {
            height: 'full',
            width: 'full',
            position: 'relative',
            overflowY: 'auto',
            float: 'start',
        },
    },
    variants: {
        isMobile: {
            true: {
                container: {
                    '@supports (height: 100dvh)': {
                        height: '[calc(100dvh - var(--play-nav-height))]',
                    },
                },
            },
            false: {
                container: {
                    [`@media screen and (max-width: ${minGameWidth})`]: {
                        minWidth: `[${minGameWidth}]`,
                    },
                },
                content: {
                    [`@media screen and (min-width: ${maxGameWidth})`]: {
                        width: '[75vw]',
                        top: '[50%]',
                        left: '[50%]',
                        transform: 'translate(-50%, -50%)',
                        boxShadow: '[0 0 10px rgba(0, 0, 0, 0.5)]',
                    },
                    [`@media screen and (min-height: ${maxGameHeight})`]: {
                        height: '[55vh]',
                        top: '[50%]',
                        left: '[50%]',
                        transform: 'translate(-50%, -50%)',
                        boxShadow: '[0 0 10px rgba(0, 0, 0, 0.5)]',
                    },
                    [`@media screen and (max-height: calc(${minGameHeight} - 1px))`]: {
                        height: `[calc(${minGameHeight} - var(--play-nav-height))]`,
                    },
                },
            },
        },
    },
    defaultVariants: {
        isMobile: false,
    },
})
